const DEFAULT_POST_LANGUAGE = 'es'

const ACTION_INTENTS = {
	CREATE: 'create-post',
	EDIT: 'edit-post',
	UPLOAD_IMAGE: 'upload-image',
	TRANSLATE: 'translate-post',
	DELETE: 'delete-post',
} as const

export { DEFAULT_POST_LANGUAGE, ACTION_INTENTS }
